class NonAvailableError extends Error {
  constructor(message) {
    super()
    this.name = 'NonAvailableError'
    this.message = message || 'Sorry, there was a technical issue'
  }
}

export default NonAvailableError
